import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-related-project-posts .swiper.grid-multi-cards'
);

if (sliders.length > 0) {
	const intialUrl = new URL(window.location);
	const backstop = intialUrl.searchParams.get('backstop');

	sliders.forEach((slider) => {
		const slideContainer = slider.querySelector('.swiper-wrapper');
		const slides = slider.querySelectorAll('.swiper-slide');
		const slideCount = slides.length;

		if (slideCount < 8) {
			const duplicatesNeeded = 8;
			for (let i = 0; i < duplicatesNeeded; i++) {
				const duplicateSlide = slides[i % slideCount].cloneNode(true);
				slideContainer.appendChild(duplicateSlide);
			}
		}
		const settings = {
			loop: true,
			slidesPerView: 3.5,
			spaceBetween: 10,
			loopAdditionalSlides: 1,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'progressbar',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 10,
				},
				576: {
					slidesPerView: 1,
					spaceBetween: 10,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 15,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
			},
		};

		if (backstop) {
			settings.autoplay = false;
		}

		new Swiper(slider, settings);
	});
}
